/**
 * Pull the affected row's id out of a modify-meal-option-foods response.
 *
 * The optimistic card is created before the server has assigned an id, so this
 * is how it learns one. Returning null here is not harmless: the card stays
 * id-less, `buildCardRowFromFood` then discards it from every subsequent merge,
 * and the card is deleted from the list as soon as its sync marker is released.
 *
 * The payload is wrapped twice before it reaches us — `post()` returns
 * `{ data: httpBody, status }` and `dietOk()` wraps that again — so
 * `res.data.data` is the HTTP body, and the rows live one level below it:
 *
 *   { message, summary, data: { event_type_id, meal_option_foods: [ { id, … } ] } }
 *
 * The target-plan endpoint keys rows `meal_option_foods`, the template endpoint
 * `foods` (mirroring their request shapes). The shallower lookups are kept as
 * fallbacks so a future envelope change degrades instead of silently breaking.
 */
export const newFoodId = (res) => {
  const rowIn = (body) => body?.meal_option_foods?.[0] ?? body?.foods?.[0];
  const httpBody = res?.data?.data;
  const row = rowIn(httpBody?.data) ?? rowIn(httpBody) ?? rowIn(res?.data);
  return row?.id ?? null;
};

/**
 * The server reports what it actually did. `skipped` means the operation was
 * ignored (e.g. the row already exists) — a 2xx that did not apply, which is
 * otherwise indistinguishable from success.
 */
export const foodQuantitySummary = (res) =>
  res?.data?.data?.summary?.food_quantity_summary ?? null;
